import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  signal,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SessionService } from '@core/services/session.service';
import { ChatService } from '../services/chat.service';
import { ChatMessageComponent } from '../chat-message/chat-message.component';
import { debounceTime, fromEvent } from 'rxjs';
import { ChatMessage } from '../interfaces/chat.interface';
import { ModalService } from '@features/modals/services/modal.service';
@Component({
  selector: 'app-chat-messages',
  imports: [ChatMessageComponent],
  templateUrl: './chat-messages.component.html',
  styleUrl: './chat-messages.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessagesComponent {
  @ViewChild('messages', { static: true }) messagesContainer!: ElementRef;

  private readonly destroyRef = inject(DestroyRef);
  showScrollBottomButton = signal(false);
  isActiveScroll = signal(false);

  features = signal([
    {
      title: 'Mute',
      action: (message: ChatMessage) =>
        this.modalService.openModal('AdminUserMuteModal', {
          user: message.profile,
        }),
    },
    {
      title: 'Delete',
      action: (message: ChatMessage) =>
        message && this.chatService.deleteMessage(message),
    },
    {
      title: 'Delete All',
      action: (message: ChatMessage) =>
        this.chatService.deleteMessages(message),
    },
  ]);

  constructor(
    public chatService: ChatService,
    public sessionService: SessionService,
    public viewContainerRef: ViewContainerRef,
    private modalService: ModalService
  ) {
    afterRenderEffect(() => {
      const messages = this.chatService.messages();
      if (messages.length > 0 && !this.isActiveScroll()) {
        this.goDown();
      }
    });
  }

  ngAfterViewInit() {
    fromEvent(this.messagesContainer.nativeElement, 'scroll')
      .pipe(debounceTime(150), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        const element = this.messagesContainer?.nativeElement;
        const scrollOffset =
          element?.scrollHeight - element?.scrollTop - element?.clientHeight;
        const threshold = 10;
        const scrollThreshold = 1;

        this.isActiveScroll.set(
          Math.abs(
            element.scrollTop - (element.scrollHeight - element.clientHeight)
          ) > scrollThreshold
        );
        this.showScrollBottomButton.set((scrollOffset ?? 0) > threshold);
      });
  }

  goDown() {
    this.messagesContainer.nativeElement.scrollTo({
      top: this.messagesContainer.nativeElement.scrollHeight,
      behavior: 'smooth',
    });
  }
}
